const styles = {
    content: {
        textAlign: 'center'
    },
    okContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/FirebaseSetting/FirebaseSetting.css.js